import classNames from "classnames";
import noop from "lodash/noop";
import { FunctionComponent, useEffect } from "react";
import { ReactComponent as IconCheck } from "@Icons/16x16/check.svg";
import "./style.scss";

interface Props {
  checked: boolean;
  disabled?: boolean;
  error?: boolean;
  onChange: () => void;
  size: "s" | "m";
  label?: string;
  type: "primary" | "secondary";
}

const CheckboxWithLabelSmily: FunctionComponent<Props> = ({
  checked,
  disabled = false,
  error = false,
  onChange,
  size,
  label,
  type,
}) => {
  useEffect(() => {
    if (error && checked) {
      onChange();
    }
  }, [error]);

  return (
    <div
      className={classNames(
        `CheckboxWithLabelSmily CheckboxWithLabelSmily--size-${size} CheckboxWithLabelSmily--type-${type}`,
        {
          "CheckboxWithLabelSmily--checked": checked,
          "CheckboxWithLabelSmily--disabled": disabled,
          "CheckboxWithLabelSmily--error": error,
        }
      )}
      onClick={disabled ? noop : onChange}
      tabIndex={disabled || error ? undefined : 1}
    >
      <div className="CheckboxWithLabelSmily-square">
        <IconCheck />
      </div>
      {label && <span className="CheckboxWithLabelSmily-label">{label}</span>}
    </div>
  );
};

export default CheckboxWithLabelSmily;
